module.exports = __webpack_public_path__ + "img/callbacks.ef152a9d.svg";